import React from "react";
import { ArrowDown } from "lucide-react";
import { DiamondDivider, Overline } from "./Shared";

export const Hero = ({ t }) => {
  const hero = t.hero;
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="home" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/16573669/pexels-photo-16573669.jpeg"
          alt="Luxury architecture"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-aa-green/80" />
        <div className="absolute inset-0 bg-gradient-to-r from-aa-green via-aa-green/85 to-aa-green/40" />
      </div>

      {/* Architectural line motif */}
      <svg className="absolute right-0 bottom-0 w-[45%] max-w-2xl opacity-[0.12] pointer-events-none" viewBox="0 0 400 400" fill="none">
        {[...Array(8)].map((_, i) => (
          <rect key={i} x={40 + i * 14} y={400 - (i + 1) * 42} width="60" height={(i + 1) * 42} stroke="#D4AF37" strokeWidth="1" />
        ))}
      </svg>

      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8 w-full pt-28">
        <div className="max-w-3xl reveal is-visible">
          <Overline>{hero.overline}</Overline>
          <h1 className="font-heading font-light tracking-tight text-aa-cream mt-6 text-4xl sm:text-6xl lg:text-7xl leading-[1.05]">
            {hero.title1} <br className="hidden sm:block" />
            {hero.title2}
            <span className="block text-aa-gold mt-3">{hero.titleAccent}</span>
          </h1>

          <div className="mt-9 flex items-center gap-3">
            <span className="diamond" />
            <p className="font-body italic text-aa-cream/80 text-base sm:text-lg tracking-wide">
              {hero.slogan}
            </p>
          </div>

          <div className="mt-11 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-services"
              onClick={() => go("services")}
              className="font-body text-xs uppercase tracking-[0.2em] bg-aa-gold text-aa-green px-8 py-4 hover:bg-aa-cream transition-colors"
            >
              {hero.cta1}
            </button>
            <button
              data-testid="hero-cta-contact"
              onClick={() => go("contact")}
              className="font-body text-xs uppercase tracking-[0.2em] border border-aa-gold/50 text-aa-cream px-8 py-4 hover:border-aa-gold hover:text-aa-gold transition-colors"
            >
              {hero.cta2}
            </button>
          </div>
        </div>
      </div>

      <button
        onClick={() => go("about")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-aa-gold/80 hover:text-aa-gold transition-colors"
        aria-label="Scroll"
      >
        <span className="font-body text-[10px] uppercase tracking-[0.3em]">{hero.scroll}</span>
        <ArrowDown size={18} strokeWidth={1.2} className="animate-bounce" />
      </button>

      <DiamondDivider className="absolute bottom-0 left-0 right-0 pb-3 opacity-0" />
    </section>
  );
};
